import {
	AsyncTransitionHomeRenderer,
	AsyncWelcomeModalRenderer,
} from '@atlassian/jira-eoc-changeboarding-layout/src/index.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { composeLayouts, type Layout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';

export const homepageLayout: Layout = composeLayouts(globalLayout, {
	// both of the components are wrapped with componentWithCondition
	globalComponents: [AsyncTransitionHomeRenderer, AsyncWelcomeModalRenderer],
});
